/* eslint-disable no-unused-vars */
import Vue from 'vue';
import Vuex from 'vuex';


/* eslint-disable import/no-cycle */

import router from '@/router';
import {
	GetTotalPoundsProducedAllYears,
	InsectSproc,
	QualitySproc,
	YieldByVarietySproc,
	YieldByVarietySprocAllYears,
	QualitySprocAllYears,
	QualityByFieldSprocAllYears,
	InsectSprocAllYears,
	InsectByFieldSprocAllYears,
	QualityByVarietySprocAllYears,
	InsectByVarietySprocAllYears,
	YieldByFieldSprocAllYears,
	Login,
	EmailReport,
	GetYearsAvailable,
	GetFormsAvailable,
	GetCustomStatus,
	ForgotPassword,
	ResetPassword
} from '@/lib/API';



Vue.use( Vuex );

export default new Vuex.Store( {
	state : {
		userInfo : {},

		navbarDisplay : true,

		accessToken       : false,
		accessTokenExpiry : false,

		contact : null,

		selectedContract : null,
		contractYear : null,
		rttNums : [],

		getYearsAvailable : [],
		getCustomStatus: [],
		getFormsAvailable : [],

		paymentScheduleAvail: true,

		entitySummaryData : {
			PayableYield : {
				id        : 'PayableYield',
				title     : 'Payable Pounds',
				subtitle  : 'This shows your payable yield from the last 5 years. ',
				chartData : [],
				type      : 'BarChart'
			},
			QualitySummary : {
				id        : 'QualitySummary',
				title     : 'Quality Summary',
				subtitle  : 'This is the quality of crop you produced this year.',
				chartData : [],
				type      : 'BarChart'
			},
			InsectDamage : {
				id        : 'InsectDamage',
				title     : 'Insect Damage',
				subtitle  : 'This shows the overall impact insects had on your crops this year.',
				chartData : [],
				type      : 'BarChartText'
			}
		},

		varietySummaryData : {
			PayableYield : {
				id        : 'PayableYield',
				title     : 'Payable Pounds',
				subtitle  : 'This is the payable yield for the selected year for all varieties.',
				chartData : [],
				type      : 'BarChart'
			},
			QualitySummary : {
				id        : 'QualitySummary',
				title     : 'Quality Summary',
				subtitle  : 'This shows the quality of your crop varieties.',
				chartData : [],
				type      : 'StackedBarChart'
			},
			InsectDamage : {
				id        : 'InsectDamage',
				title     : 'Insect Damage',
				subtitle  : 'This shows the impact insects had on each variety of your crop.',
				chartData : [],
				type      : 'BarChartText'
			}
		},

		fieldSummaryData : {
			PayableYield : {
				id        : 'PayableYield',
				title     : 'Payable Pounds',
				subtitle  : 'This is the payable yield for the selected for each of your fields.',
				chartData : [],
				type      : 'BarChart'
			},
			QualitySummary : {
				id        : 'QualitySummary',
				title     : 'Quality Summary',
				subtitle  : 'This shows the quality for each of your fields.',
				chartData : [],
				type      : 'StackedBarChart'
			},
			InsectDamage : {
				id        : 'InsectDamage',
				title     : 'Insect Damage',
				subtitle  : 'This shows the amount of product impacted by insect damage. ',
				chartData : [],
				type      : 'BarChartText'
			}
		},

		paymentScheduleData : {
			PaymentSchedule : {
				id        : 'PaymentSchedule',
				title     : 'Payment Schedule',
				subtitle  : 'Tap a bar on the graph to view the breakdown of Edible Kernels and Open Inshell.',
				chartData : [],
				type      : 'BarChart'
			},
			PayablevsAssessableWeight : {
				id        : 'PayablevsAssessableWeight',
				title     : 'Payable vs Assessable Weight',
				subtitle  : 'This shows the type of product that made up your payable and assessable weight.',
				chartData : [],
				type      : 'StackedBarChart'
			},
		}

	},
	getters : {

		selectedContract     : state => state.selectedContract,
		entitySummaryData    : state => state.entitySummaryData,
		varietySummaryData   : state => state.varietySummaryData,
		fieldSummaryData     : state => state.fieldSummaryData,
		paymentScheduleData  : state => state.paymentScheduleData,
		contact              : state => state.contact,
		getFormsAvailable    : state => state.getFormsAvailable,
		getYearsAvailable    : state => state.getYearsAvailable,
		getCustomStatus      : state => state.getCustomStatus,
		getContractYear      : state => state.contractYear,
		getAccessToken       : state => state.accessToken,
		paymentScheduleAvail : state => state.paymentScheduleAvail
	},
	mutations : {
		/* eslint-disable no-param-reassign */
		showNavbar( state ) {
			state.navbarDisplay = true;
		},
		hideNavbar( state ) {
			state.navbarDisplay = false;
		},

		setAccessToken( state, payload ) {
      //console.log('set Access Token : ');
      const { accessToken:stateAT } = state;
      const { accessToken:payloadAT } = payload;
      //console.log(`${stateAT} to => ${payloadAT}`);
			state.accessToken = payload.accessToken;
			state.accessTokenExpiry = payload.accessTokenExpiry;
      //console.log('done', state.accessToken);
		},

		selectContract( state, contract ) {
			state.selectedContract = contract;
		},

		setRttNums( state, rttNums ) {
			state.rttNums = rttNums;
		},

		getContact( state, data ) {
			state.contact = data.user;
		},

		setEntitySummaryDataPayableYield( state, data ) {
			state.entitySummaryData.PayableYield.chartData = data;
		},
		setEntitySummaryDataQualitySummary( state, data ) {
			state.entitySummaryData.QualitySummary.chartData = data;
		},
		setEntitySummaryDataInsectDamage( state, data ) {
			state.entitySummaryData.InsectDamage.chartData = data;
		},
		setVarietySummaryDataPayableYield( state, data ) {
			state.varietySummaryData.PayableYield.chartData = data;
		},
		setFieldSummaryDataPayableYield( state, data ) {
			state.fieldSummaryData.PayableYield.chartData = data;
		},
		setVarietySummaryDataQualitySummary( state, data ) {
			state.varietySummaryData.QualitySummary.chartData = data;
		},
		setVarietySummaryDataInsectDamage( state, data ) {
			state.varietySummaryData.InsectDamage.chartData = data;
		},
		setFieldSummaryDataQualitySummary( state, data ) {
			state.fieldSummaryData.QualitySummary.chartData = data;
		},
		setFieldSummaryDataInsectDamage( state, data ) {
			state.fieldSummaryData.InsectDamage.chartData = data;
		},
		getFormsAvailable( state, data ) {
			state.getFormsAvailable = data;
		},
		getYearsAvailable( state, data ) {
			state.getYearsAvailable = data;
		},
		getCustomStatus( state, data) {
			state.getCustomStatus = data;
		},
		setContractYear( state, data ) {
			state.contractYear = data;	
		},
	},
	actions : {
		showNavbar( { commit } ) {
			commit( 'showNavbar' );
		},

		hideNavbar( { commit } ) {
			commit( 'hideNavbar' );
		},

		setAccessToken( { commit }, payload ) {
      const { user, accessToken } = payload;
      if(user) {
        commit('setUserInfo', user);
      }
      if(accessToken) {
        commit('setAccessToken', payload);
      }
		},
		setUserStuff( { commit }, user ) {
			commit( 'setUserStuff', user );
		},

		selectContract( { commit }, contract ) {
			commit( 'selectContract', contract );
		},

		setRttNums( { commit }, rttNums ) {
			commit( 'setRttNums', rttNums );
		},

		setContractYear( { commit }, contractYear ) {
			commit( 'setContractYear', contractYear );
		},
		setContact( { commit }, data ) {
			commit('getContact', data);
			commit( 'setAccessToken', data );
		},

    async RefreshToken( { commit }, Token ) {
			await commit( 'setContact', Token );
			await commit( 'setAccessToken', Token );
    },

		async Login( { commit }, credentials ) {
			await Login( credentials )
				.then( ( data ) => {
          //console.log('success');
          //console.log(data);
					commit( 'getContact', data );
					commit( 'setAccessToken', data );
					router.push( 'app' );
				} )
				.catch( ( e ) => {
          //console.log('Login error from store');
					//console.warn( e );
					throw e;
				} );
		},

		async ForgotPassword( { commit }, email ) {
			await ForgotPassword( email )
				.then( ( data ) => data )
				.catch( ( e ) => {
					console.warn( e );
					throw e;
				} );
		},

		async ResetPassword( { commit }, data ) {
			await ResetPassword( data.token, data.password )
				.then( ( response ) => response )
				.catch( ( e ) => {
					console.warn( e );
					throw e;
				} );
		},

		async emailReport( { commit }, data ) {
			await EmailReport( data)
			.then( ( i ) => {
				// commit( 'emailReport', i );
			} );
		},

		async setEntitySummaryDataPayableYield( { commit }, ContractNum ) {
			await GetTotalPoundsProducedAllYears( ContractNum )
				.then( ( data ) => {
					commit( 'setEntitySummaryDataPayableYield', data );
				} );
		},

		async setEntitySummaryDataQualitySummary( { commit }, ContractNum ) {

			await QualitySprocAllYears( ContractNum )
				.then( ( data ) => {
					commit( 'setEntitySummaryDataQualitySummary', data );
				} );
		},

		async setEntitySummaryDataInsectDamage( { commit }, ContractNum ) {
			await InsectSprocAllYears( ContractNum )
				.then( ( data ) => {
					commit( 'setEntitySummaryDataInsectDamage', data );
				} );
		},

		async setVarietySummaryDataPayableYield( { commit }, args ) {
			await YieldByVarietySprocAllYears( args )
				.then( ( data ) => {
					commit( 'setVarietySummaryDataPayableYield', data );
				} );
		},

		async setVarietySummaryDataQualitySummary( { commit }, args ) {
			await QualityByVarietySprocAllYears( args )
				.then( ( data ) => {
					commit( 'setVarietySummaryDataQualitySummary', data );
				} );
		},

		async setVarietySummaryDataInsectDamage( { commit }, args ) {
			await InsectByVarietySprocAllYears( args )
				.then( ( data ) => {
					commit( 'setVarietySummaryDataInsectDamage', data );
				} );
		},

		async setFieldSummaryDataPayableYield( { commit }, args ) {
			await YieldByFieldSprocAllYears( args )
				.then( ( data ) => {
					commit( 'setFieldSummaryDataPayableYield', data );
				} );
		},

		async setFieldSummaryDataQualitySummary( { commit }, args ) {
			await QualityByFieldSprocAllYears( args )
				.then( ( data ) => {
					commit( 'setFieldSummaryDataQualitySummary', data );
				} );
		},

		async setFieldSummaryDataInsectDamage( { commit }, args ) {
			await InsectByFieldSprocAllYears( args )
				.then( ( data ) => {
					commit( 'setFieldSummaryDataInsectDamage', data );
				} );
		},
		async getFormsAvailable( { commit } ) {
			await GetFormsAvailable()
				.then( (data) => {
					commit( 'getFormsAvailable', data );
				} );
		},
		async getYearsAvailable( { commit } ) {
			await GetYearsAvailable()
				.then( (data) => {
					commit( 'getYearsAvailable', data );
				} );
		},
		async getCustomStatus( { commit }, args ) {
			await GetCustomStatus(args)
			.then( (data) => {
				commit( 'getCustomStatus', data);
			});
		}
	},
	modules : {
	},
} );
